<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-signup-on': this.state == 'signup',
        'login-forgot-on': this.state == 'forgot'
      }"
      id="kt_login"
    >
      <!--begin::Aside-->
      <div
        class="login-aside d-flex flex-column flex-row-auto d-none s-none"
        style="background-color: #F2C98A;"
      >
        <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <a href="#" class="text-center mb-10">
            <img
              src="media/logos/logo-letter-1.png"
              class="max-h-70px"
              alt=""
            />
          </a>
          <h3
            class="font-weight-bolder text-center font-size-h4 font-size-h1-lg"
            style="color: #986923;"
          >
            Discover Amazing Metronic <br />with great build tools
          </h3>
        </div>
        <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div>
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-0 mx-auto"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <a href="#" class="text-center mb-10">
              <img
                src="media/logos/logo-rgm.png"
                class="max-h-80px mb-4"
                alt=""
              />
            </a>

            <v-form
                v-on:submit.prevent="login"
                v-model="validForm"
                id="kt_login_signin_form"
                ref="kt_login_signin_form"
                >
              <div class="pb-13 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                >
                  Bienvenido
                </h3>
                <span class="text-muted font-weight-bold font-size-h4 d-none"
                  >New Here?
                  <a
                    id="kt_login_signup"
                    class="text-primary font-weight-bolder"
                    @click="showForm('signup')"
                    >Create an Account</a
                  ></span
                >
              </div>
              <div class="form-group">
                <label class="font-size-h6 font-weight-bolder text-dark"
                  >Correo electrónico</label
                >
                <div
                  id="example-input-group-1"
                  label=""
                  label-for="example-input-1"
                >
                  <v-text-field
                    outlined
                    class=""
                    type="text"
                    name="email"
                    ref="email"
                    maxlength="150"
                    v-model="form.username"
                    :rules="[
                      validEmail('')
                    ]"
                  />
                </div>
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mt-n5">
                  <label class="font-size-h6 font-weight-bolder text-dark pt-5"
                    >Contraseña</label
                  >
                  <a
                    class="text-primary font-size-h6 font-weight-bolder text-hover-primary pt-5"
                    id="kt_login_forgot"
                    @click="showForm('forgot')"
                    > &nbsp;¿Olvidaste tu contraseña?</a
                  >
                </div>
                <div
                  id="example-input-group-2"
                  label=""
                  label-for="example-input-2"
                >
                <!--form-control form-control-solid h-auto py-7 px-6 rounded-lg-->
                  <v-text-field
                    outlined
                    class=""
                    type="password"
                    name="password"
                    ref="password"
                    v-model="form.password"
                    autocomplete="off"
                    maxlength="50"
                    :rules="[
                      minLength('', 8)
                    ]"
                  />
                </div>
              </div>
              <div class="pb-lg-0 pb-5">
                <button
                  ref="kt_login_signin_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                  :disabled="!validForm"
                >
                  Iniciar Sesión
                </button>
                
              </div>
            </v-form>
            <div>
              <small>RGM v.6.21.0 Últ. Act. 10/09/2026 12:00 pm.</small>
            </div>
          </div>
          <!--end::Signin-->
          <!--begin::Signup-->
          <div class="login-form login-signup">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signup_form"
            >
              <div class="pb-13 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                >
                  Sign Up
                </h3>
                <p class="text-muted font-weight-bold font-size-h4">
                  Enter your details to create your account
                </p>
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="text"
                  placeholder="Fullname"
                  name="fullname"
                  ref="fullname"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="email"
                  placeholder="Email"
                  name="email"
                  ref="remail"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Password"
                  name="password"
                  ref="rpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                  type="password"
                  placeholder="Confirm password"
                  name="cpassword"
                  ref="cpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="checkbox mb-0">
                  <input type="checkbox" name="agree" />
                  <span class="mr-2"></span>
                  I Agree the
                  <a href="#" class="ml-2">terms and conditions</a>.
                </label>
              </div>
              <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
                <button
                  ref="kt_login_signup_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                  style="width:150px;"
                >
                  Submit
                </button>
                <button
                  type="button"
                  id="kt_login_signup_cancel"
                  class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                  @click="showForm('signin')"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
          <!--end::Signup-->
          <!--begin::Forgot-->
          <div class="login-form login-forgot">
            <!--begin::Form-->
            <!--<form
              class="form"
              novalidate="novalidate"
              id="kt_login_forgot_form"
              ref="kt_login_forgot_form"
            >-->
            <v-form
                v-on:submit.prevent="resetPassEmail"
                v-model="validFormReset"
                id="kt_login_forgot_form"
                ref="kt_login_forgot_form"
                >
              <div class="pb-13 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                >
                  ¿Olvidaste tu contraseña?
                </h3>
                <p class="text-muted font-weight-bold font-size-h4">
                  Ingresa tu correo electrónico para reestablecer tu contraseña
                </p>
              </div>
              <div class="form-group">
                <v-text-field
                  outlined
                  class="gray-bg"
                  type="email"
                  placeholder="Correo electrónico"
                  name="email"
                  autocomplete="off"
                  v-model="datosResetPass.correoElectronico"
                  :rules="[
                    required('Correo Electrónico'),
                    validEmail('Correo Electrónico')
                    ]"
                />
              </div>
              <div class="form-group d-flex flex-wrap pb-lg-0">
                <button
                  id="kt_login_forgot_submit"
                  ref="kt_login_forgot_submit"
                  class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                  :disabled="!validFormReset"
                  type="submit"
                >
                  Restablecer contrase&ntilde;a
                </button>
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                  @click="showForm('signin')"
                  :disabled="cancelResetDisabled"
                >
                  Cancelar
                </button>
              </div>
            </v-form>
          </div>
          <!--end::Forgot-->
        </div>
        <!--begin::Content footer-->
        <div
          class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0 s-none"
        >
          <a href="#" class="text-primary font-weight-bolder font-size-h5"
            >Términos de uso</a>
          <!--<a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5"
            >Planes</a>-->
          <a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5"
            >Contacto</a>
        </div>
        <!--end::Content footer-->
      </div>
      <!--end::Content-->
    </div>
    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
//import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
//import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
//import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
//import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import SnackAlert from '@/view/content/SnackAlert.vue';

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import { RESTABLECER_PASS_BY_EMAIL } from "@/core/services/store/usuarios/usuario.module";

//import Swal from "sweetalert2";

import validations from "@/core/untils/validations.js";

export default {
  name: "login-1",
  components: {
    SnackAlert
  },
  data() {
    return {
      state: "signin",
      // Remove this dummy login info
      form: {
        username: "", //admin@demo.com
        password: "" //demo
      },
      datosResetPass:{
        correoElectronico:'',
      },
      validForm:false,
      validFormReset: false,
      cancelResetDisabled:false,
      emailReset:'',
      ...validations

    };
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    }
  },
  mounted() {
    //const signin_form = KTUtil.getById("kt_login_signin_form");
    //onst signup_form = KTUtil.getById("kt_login_signup_form");
    //const forgot_form = KTUtil.getById("kt_login_forgot_form");

    /*this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Username is required"
            }
          }
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });*/

    /*this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Full name is required"
            }
          }
        },
        email: {
          validators: {
            notEmpty: {
              message: "Email is required"
            },
            emailAddress: {
              message: "The value is not a valid email address"
            }
          }
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required"
            }
          }
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required"
            },
            identical: {
              compare: function() {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "The password and its confirm are not the same"
            }
          }
        },
        agree: {
          validators: {
            notEmpty: {
              message: "You should agree terms and conditions"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv2 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email is required"
            },
            emailAddress: {
              message: "The value is not a valid email address"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });*/

    /*this.fv.on("core.form.valid", () => {


      var email = this.form.email;
      var password = this.form.password;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      //setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { email, password })
          // go to which page after successfully login
          .then(res => { 
            if(res.status===200 && res.token){
              this.$router.push({ name: "dashboard" })
            } else {
              this.$refs.snackalert.SnackbarShow('warning', 'Error', res.message);
            }
            submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
            
            })
          .catch(() => {
            this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', 'Ha ocurrido un error, por favor, ponte en contacto con el administrador del sistema.');
             submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
          });

        
     // }, 2000);
    //});

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: "Please, provide correct data!",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false
      });
    });

    this.fv1.on("core.form.valid", () => {
      const email = this.$refs.remail.value;
      const password = this.$refs.rpassword.value;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signup_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send register request
        this.$store
          .dispatch(REGISTER, {
            email: email,
            password: password
          })
          .then(() => this.$router.push({ name: "dashboard" }));

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }, 2000);
    });

    this.fv1.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: "Please, provide correct data!",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false
      });
    });*/
  },
  methods: {
    showForm(form) {
      //console.log(form)
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },


    async login(){
    //  console.log("En login1");
      //var email = this.form.username;
      //var password = this.form.password;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      //setTimeout(() => {
        // send login request
      await this.$store
          .dispatch(LOGIN, this.form)
          // go to which page after successfully login
          .then(res => { 
            // console.log("Respuesta:", res);
          // console.log("Respuesta:");
          //   console.log(res.status)
            // console.log(res);
            this.$router.replace({ name: 'dashboard-informador', force: true });
            if(res.status===200 && res.data.token){
              //currentRoles.includes(4)

             // estado = data.estadoId;

              let stRoles = res.data.roles.map(a => a.idRol);
              // let stRoles = res.data.roles.push(4);

              /*console.log(res.data.roles);
              console.log(stRoles)
              */



            //  console.log("Rol:");
            //  console.log(stRoles);
            //  console.log("---");



              if(stRoles.includes(1)){
                //window.location.replace('/dashboard-informador');
                //console.log("aqui")
                 this.$router.replace({ name: 'dashboard-master-instituciones', force: true });
              }
              //Revisor/Aprobador
              else if(stRoles.includes(2) || stRoles.includes(3)){
                //window.location.replace('/dashboard-informador');
                 this.$router.replace({ name: 'dashboard-revisor-aprobador', force: true });
              }
              else if(stRoles.includes(4)){
                //window.location.replace('/dashboard-informador');
                 this.$router.replace({ name: 'dashboard-informador', force: true });
              } else if(stRoles.includes(5)){
                this.$router.replace({ name: 'dashboard-creador', force: true });
              }
              else {
                //window.location.replace('/');
                this.$router.replace({ name: 'dashboard', force: true });
              }
              //this.$router.push({ name: "dashboard" })
            } else {
              if(res.message){
                this.$refs.snackalert.SnackbarShow('warning', 'Error', res.message);
              } else {
                this.$refs.snackalert.SnackbarShow('warning', 'Error', 'Ha ocurrido un error de conexión, por favor, ponte en contacto con el administrador del sistema. Login1');
              }
              this.form.password='';
            }
            submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
            
            })
          .catch(() => {
             this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', 'Ha ocurrido un error, por favor, ponte en contacto con el administrador del sistema. catchlogin1');
             submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
             this.form.password='';
          });
    },
    register(){
      this.$store
          .dispatch(REGISTER, {
            email: this.form.username,
            password: this.form.password
            })
      .then(() => this.$router.push({ name: "dashboard" }));
    },

    async resetPassEmail(){
      this.cancelResetDisabled=true;
      const forgetButton = this.$refs["kt_login_forgot_submit"];
      forgetButton.classList.add("spinner", "spinner-light", "spinner-right");
      
       await this.$store
          .dispatch(RESTABLECER_PASS_BY_EMAIL, this.datosResetPass)
          // go to which page after successfully login
          .then(res => { 
            //console.log(res)
            if(res.status===200){
              this.$refs.snackalert.SnackbarShow('info', 'Mensaje', res.message);
              this.showForm("signin");
            } else {
              this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', res.message);
            }
            forgetButton.classList.remove("spinner", "spinner-light", "spinner-right");
            this.cancelResetDisabled=false;
          })
          .catch(err => {
            console.log(err)
             this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', 'Ha ocurrido un error, por favor, ponte en contacto con el administrador del sistema.');
            // submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
             //this.emailReset='';
             forgetButton.classList.remove("spinner", "spinner-light", "spinner-right");
             this.cancelResetDisabled=false;
          });

    }
  }
};
</script>
<style lang="scss">
.v-application {
  .s-none {
    display: none !important;
  }
}

.gray-bg {
  .v-input__control{

    .v-input__slot{
        background-color: #f3f6f9 !important;
    }
  }

}

</style>